export const ROUTES = {
  // Home/main routes
  HOME: '/',
  ARTICLE: '/article/:slug',
  ARTICLE_BY_SLUG: (slug: string) => `/article/${slug}`,
  CATEGORY: '/category/:slug',
  CATEGORY_BY_SLUG: (slug: string) => `/category/${slug}`,
  
  // Bare Acts
  BARE_ACTS: '/bare-acts',
  BARE_ACT: '/bare-acts/:actSlug',
  BARE_ACT_BY_SLUG: (slug: string) => `/bare-acts/${slug}`,
  
  // // Courts
  // COURTS: '/courts',
  // COURT_BY_SLUG: (slug: string) => `/courts/${slug}`,
  
  // Law firms
  LAW_FIRMS: '/law-firms',
  LAW_FIRMS_SECTION: '/law-firms/:subsection',
  
  // Auth routes
  AUTH: '/auth',
  LOGIN: '/auth?mode=login',
  REGISTER: '/auth?mode=register',
  VERIFY_EMAIL: '/verify-email',
  PROFILE: '/profile',
  SAVED_ARTICLES: '/saved-articles',
  
  // Info pages
  ABOUT: '/about',
  CONTACT: '/contact',
  PRIVACY: '/privacy-policy',
  TERMS: '/terms-of-use',
  ADVERTISE: '/advertise',
  
  // Subscription related
  SUBSCRIBE: '/subscribe-premium',
  GIFT_PREMIUM: '/gift-premium',
  
  // Error page
  NOT_FOUND: '*'
};